import React from 'react'

import NProgress from 'react-nprogress'

import ActionCableMessaging from 'Pods/Shared/Messaging/ActionCableMessaging'
import withRouter from 'Pods/Shared/withRouter'

import Breadcrumb from './Components/Breadcrumb'
import Header from './Components/Header'
import HeaderWithTwoLines from './Components/HeaderWithTwoLines'
import Sidebar from './Components/Sidebar'

class Conversation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: {
        id: '0',
        type: 'conversations',
        attributes: {
          subject: '',
          archived: false,
          suspendedMessaging: false,
          type: 'personal',
          typeData: {},
        },
        relationships: { recentAttachments: { data: [] }, recipient: { data: { id: 0, type: 'recipients' } } },
      },
      recipient: {
        id: '0',
        type: 'recipients',
        attributes: {
          username: '',
          avatar: {
            url: null,
          },
          responseRate: 0,
          responseTime: 0,
          jobsCompleted: 0,
          itemsCount: 0,
          allowPrivateJobRequests: true,
          profileUrl: '',
        },
      },
      attachments: [],
    }

    this.onFetchConversationSuccess = this.onFetchConversationSuccess.bind(this)
    this.onFetchConversationFailure = this.onFetchConversationFailure.bind(this)
    this.updateAttachments = this.updateAttachments.bind(this)
    this.updateOffer = this.updateOffer.bind(this)
    this.onMoveToArchiveSuccess = this.onMoveToArchiveSuccess.bind(this)
    this.onReportSuccess = this.onReportSuccess.bind(this)
    this.onRemoveOfferSuccess = this.onRemoveOfferSuccess.bind(this)
    this.onPriceOfferSubmitSuccess = this.onPriceOfferSubmitSuccess.bind(this)
    this.onPriceOfferDecisionSuccess = this.onPriceOfferDecisionSuccess.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.fetchConversation()
  }

  fetchConversation() {
    NProgress.start()

    axios.get(`/api/internal/conversations/${this.props.match.params.id}`, { cancelToken: this.cancelSource.token })
      .then(this.onFetchConversationSuccess)
      .catch(this.onFetchConversationFailure)
  }

  onFetchConversationSuccess(response) {
    NProgress.done()

    const recipient = response.data.included.filter((incl) => incl.type === 'recipients')[0]

    this.setState({
      data: response.data.data,
      recipient,
      attachments: response.data.included.filter((incl) => incl.type === 'attachments'),
    })

    App.events.publish('app:inbox:refresh')
  }

  onFetchConversationFailure(xhr, status, err) {
    NProgress.done()
  }

  updateAttachments(attachments) {
    this.setState({
      attachments: [...(attachments.reverse()), ...this.state.attachments],
    })
  }

  updateOffer(typeData) {
    const newData = this.state.data
    newData.attributes.typeData = typeData
    newData.attributes.typeData.isOwner = !newData.attributes.typeData.isOwner
    this.setState({ data: newData })
  }

  onMoveToArchiveSuccess() {
    const newData = { ...this.state.data }
    newData.attributes.archived = true
    this.setState({ data: newData })
  }

  onRemoveOfferSuccess() {
    const newData = { ...this.state.data }
    newData.attributes.typeData.status = 'withdrawn'
    this.setState({ data: newData })
  }

  onReportSuccess() {
    this.setState({ reported: true })
  }

  onPriceOfferSubmitSuccess(response) {
    const newData = { ...this.state.data }
    newData.attributes.typeData.status = response.data.status
    newData.attributes.typeData.price = response.data.price
    this.setState({ data: newData })
  }

  onPriceOfferDecisionSuccess(response) {
    const newData = { ...this.state.data }
    newData.attributes.typeData.status = response.data.status
    this.setState({ data: newData })
  }

  render() {
    return (
      <div>
        <Breadcrumb
          subject={this.state.data.attributes.subject}
        />

        <div className="conversation">
          {this.state.data.attributes.type === 'personal'
            || this.state.data.attributes.type === 'cgtrader_support'
            || this.state.data.attributes.type === 'model_support'
            || this.state.data.attributes.type === 'model_feedback' ? (
            <Header
              type={this.state.data.attributes.type}
              typeData={this.state.data.attributes.typeData}
              archived={this.state.data.attributes.archived}
              reported={this.state.reported}
              conversationId={this.state.data.id}
              recipient={this.state.recipient.attributes.username}
              onMoveToArchiveSuccess={this.onMoveToArchiveSuccess}
              onReportSuccess={this.onReportSuccess}
            />
          ) : (
            <HeaderWithTwoLines
              type={this.state.data.attributes.type}
              typeData={this.state.data.attributes.typeData}
              archived={this.state.data.attributes.archived}
              reported={this.state.reported}
              conversationId={this.state.data.id}
              recipient={this.state.recipient.attributes.username}
              onMoveToArchiveSuccess={this.onMoveToArchiveSuccess}
              onReportSuccess={this.onReportSuccess}
              onRemoveOfferSuccess={this.onRemoveOfferSuccess}
              onPriceOfferSubmitSuccess={this.onPriceOfferSubmitSuccess}
              onPriceOfferDecisionSuccess={this.onPriceOfferDecisionSuccess}
            />
          )}
          <div className="row">
            <div className="col-12 col-md-8 col-lg-9">
              <ActionCableMessaging
                conversationId={this.props.match.params.id}
                isAttachmentsHidden={this.state.data.attributes.type === 'file_conversion_request'}
                isSuspendedMessaging={this.state.data.attributes.suspendedMessaging}
                updateAttachments={this.updateAttachments}
                updateOffer={this.updateOffer}
                isJobConversation={this.state.data.attributes.type === 'job_application'}
                conversationType={this.state.data.attributes.type}
              />
            </div>
            <div className="col-12 col-md-4 col-lg-3">
              <Sidebar
                recipient={this.state.recipient}
                attachments={this.state.attachments}
                type={this.state.data.attributes.type}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Conversation)
